import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { homeGuard } from './guards/home.guard';
import { AuthGuard } from './guards/auth.guard';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { EmbedLayoutComponent } from './components/embed-layout/embed-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [homeGuard],
      },
      {
        path: 'prototype',
        loadComponent: () => import('./pages/prototype/prototype.component').then(m => m.PrototypeComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'projects',
        loadChildren: () => import('./pages/projects/projects.routes').then(m => m.projectsRoutes),
        canActivate: [AuthGuard],
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.routes').then(m => m.adminRoutes),
        canActivate: [AuthGuard],
      },
      {
        path: 'account',
        loadChildren: () => import('./pages/account/account.routes').then(m => m.accountRoutes),
      },
      {
        path: 'manage',
        loadChildren: () => import('./pages/manage/manage.routes').then(m => m.manageRoutes),
        canActivate: [AuthGuard],
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./pages/access-denied/access-denied.component').then(m => m.AccessDeniedComponent),
      },
      {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
      },
    ],
  },
  {
    path: 'embed',
    component: EmbedLayoutComponent,
    children: [
      {
        path: 'project/:projectId/post/:postId',
        loadComponent: () => import('./pages/embed/embed.component').then(m => m.EmbedComponent),
      },
    ],
  },
  {
    path: 'project/:projectId/post/:postId/embed/:fileId',
    component: EmbedLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/embed/embed.component').then(m => m.EmbedComponent),
      },
    ],
  },
  {
    path: 'engagement',
    component: EmbedLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/engagement-form/engagement-form.component').then(m => m.EngagementFormComponent),
      },
    ],
  },
  {
    path: 'share/:token',
    loadComponent: () => import('./pages/share/share.component').then(m => m.ShareComponent),
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];
